import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=5287c4b2&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"
import style0 from "./SubMenu.vue?vue&type=style&index=0&id=5287c4b2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287c4b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5287c4b2')) {
      api.createRecord('5287c4b2', component.options)
    } else {
      api.reload('5287c4b2', component.options)
    }
    module.hot.accept("./SubMenu.vue?vue&type=template&id=5287c4b2&scoped=true", function () {
      api.rerender('5287c4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NavMenu/SubMenu.vue"
export default component.exports